import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import type { SuburbConfig } from 'config/constants/types'
import type { QaListState, QaList } from '../types'
import { getQaListings, removeQaProperty } from './helpers'

// qaListReducer

const noQaListConfig = {
  listings: [],
  isInitialized: false,
  isLoading: true,
  hasError: false,
}

interface SetListingsEditPayload {
  listings: QaList[]
}

const initialState: QaListState = { ...noQaListConfig }

export const qaListSlice = createSlice({
  name: 'QaList',
  initialState,
  reducers: {
    fetchQaListings: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    setQaListings: (state, action: PayloadAction<SetListingsEditPayload>) => {
      state.listings = action.payload.listings
      state.isLoading = false
      state.isInitialized = true
      state.hasError = false
    },
    fetchQaListingsFailed: (state) => {
      state.listings = []
      state.isInitialized = false
      state.isLoading = false
      state.hasError = true
    },
  },
})

export const fetchQaList = (userId: string) => async (dispatch) => {
  console.log(userId)
  try {
    dispatch(fetchQaListings())
    const listings = await getQaListings(userId)
    dispatch(
      setQaListings({
        listings,
      }),
    )
  } catch (error) {
    message.error('Error gettings QA list')
    dispatch(fetchQaListingsFailed())
  }
}

export const removeFromQaList = (qaId: string, propertyId: string) => async (dispatch) => {
  try {
    dispatch(fetchQaListings())
    const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
    const removeListing = await removeQaProperty(qaId, propertyId)
    console.log('removed')
    if (removeListing) {
      message.success('Listing Removed')
    }

    const listings = await getQaListings(qaId)
    console.log('get list')
    dispatch(
      setQaListings({
        listings,
      }),
    )
  } catch (error) {
    message.error('Error gettings QA list')
    dispatch(fetchQaListingsFailed())
  }
}

// Actions
export const { fetchQaListings, setQaListings, fetchQaListingsFailed } = qaListSlice.actions

export default qaListSlice.reducer
